export default "__VITE_ASSET__D02QDQkI__"